export class CodedError extends Error {
    constructor(message, code, codeString) {
        super(message);
        this.code = code;
        this.codeString = codeString;
    }
}
